import { EditorInformation } from '@decisions/server/DecisionsFramework/Design/Properties/EditorInformation';
import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties';
import { ValidationIssue } from '@decisions/server/DecisionsFramework/ValidationIssue';
import {
  aggregateValidationsByRefProp,
  GLOBAL_ISSUE_KEY,
  addValidationsByRefProp,
  clearValidations,
} from 'utils/ValidationUtils';
import { categoryIsMappingTypeSelector } from 'components/property-editors/utils/ProviderNodeUtils';

const EditorLinkBlackList = ['Edit Flow Step'];

export function includeLinkInPropertyGrid(info: EditorInformation) {
  // I don't remember where all these came from... this seems more restrictive that what was there before...
  return info.ShowInPropertyGrid && !EditorLinkBlackList.includes(info.Name) && info.MvcEditorClassName;
}

export function applyValidationUpdates(state: ContextProviderNode, validationIssues?: ValidationIssue[]) {
  // clear all validations, first.
  clearValidations(state); // maybe this would work as intended if it only cleared validations at the ref prop in question, not all of them
  // collect by ReferenceProperty:
  const validationMap = aggregateValidationsByRefProp(validationIssues);
  // add the global ones:
  state.ValidationIssues = validationMap.get(GLOBAL_ISSUE_KEY) || [];
  // apply issues to particular nodes:
  addValidationsByRefProp(state, validationMap);
}

export function getContextChildrenTotal(node?: ContextProviderNode, nodeIndex?: number) {
  if (!node || !Array.isArray(node.Children)) {
    return 0;
  }

  let count = 0;
  if (nodeIndex !== undefined) {
    // for wizard style, count only the currently visible parent node.
    let child = node.Children[nodeIndex];
    count += getContextChildrenTotal(child);
  } else {
    // default - count all of them:
    node.Children.forEach(child => {
      count += getContextChildrenTotal(child);
    });
  }

  return count + node.Children.length;
}

/**
 * Evaluate whether we can, and then whether we should hide the top category.
 * @param snapshot to evaluate
 * @param hideTopCategory defaults to true, to hide it if we can.
 * @return true if can and should hide top category
 */
export function shouldHideTopCategory(snapshot?: ContextProviderNode, hideTopCategory = true) {
  // in current data structure, if there is one root child, it has to be a category
  const couldHide = snapshot?.Children.length === 1 && !categoryIsMappingTypeSelector(snapshot.Children[0]);
  const shouldHide = couldHide && hideTopCategory;
  return shouldHide;
}
